import { ProductVariantJoinInfoDto } from 'src/types/generated';

import BaseReadApiModule from 'src/api/baseRead';

class ProductVariantApi extends BaseReadApiModule<ProductVariantJoinInfoDto> {
  protected baseRoute = '/product-variants';
}

export default ProductVariantApi;
